<div class="detail-page-action-bar flex-action-bar space-between">
    <div class="load-area">
        <button
            type="button"
            (click)="applyFilter()"
            class="btn btn-cerrix"
            [disabled]="!selectedBusinessDimensionId"
        >
            <i class="fas fa-link"></i>
            <span class="d-none d-lg-inline">{{ 'loadProcess' | t }}</span>
            @if (!selectedBusinessDimensionId) {
                <i
                    class="far fa-question-circle ms-2"
                    [matTooltip]="'pleaseSelectConfiguration' | t"
                ></i>
            }
        </button>
    </div>

    <div class="filtering-area">
        <div class="form-group smallfont">
            <label><b>{{ 'organizationLabel' | t }}</b></label>
            <cerrix-select-tree
                [placeholder]="'noSelectionMade' | t"
                [getDataMethod]="orgRequest"
                [(value)]="selectedOrganizationId"
                [multiselect]="false"
                (onChangeSingleId)="reloadBusinessData()"
            >
            </cerrix-select-tree>
        </div>

        <div class="form-group smallfont">
            <label for="businessDimenionTree">
                <b>{{ 'businessDimensionLabel' | t }}</b>
            </label>
            <cerrix-select-tree
                [placeholder]="'requiredPlaceholder' | t"
                [getDataMethod]="bdRequest"
                [(value)]="selectedBusinessDimensionId"
                [multiselect]="false"
            >
            </cerrix-select-tree>
        </div>
    </div>
</div>
